export const capitalizeFirstLastName = (result) => ({
    ...result,
    firstName: result?.firstName.toUpperCase(),
    lastName: result?.lastName.toUpperCase()
})